import { render, staticRenderFns } from "./WithdrawTransaction.vue?vue&type=template&id=e2ab7e60&"
import script from "./WithdrawTransaction.vue?vue&type=script&lang=ts&"
export * from "./WithdrawTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports